export function HomeTitle() {
  return (
    <div className="absolute inset-0 z-10 flex items-center justify-center">
      <div className="px-16 -mt-20">
        <h1 className="font-heading text-left text-[clamp(2rem,10vw,12rem)] lg:text-[clamp(2rem,12vw,12rem)] leading-[0.8] tracking-tight text-foreground">
          FROM DATA<br />TO REVENUE
        </h1>
      </div>
    </div>
  )
}
